/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from 'react'
import { Outlet, Link } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../_metronic/helpers'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  let random = Math.floor(Math.random() * 9) + 1
  random = 9;
  let bgclass = `d-flex flex-column flex-column-fluid flex-lg-row  bg-body-image bg-body-image${random}`;

  return (
    <>


      <div className={bgclass}>

        <div className="d-flex flex-center w-lg-50 pt-15 pt-lg-0 px-10">

          <div className="d-flex flex-center flex-lg-start flex-column">
            <a href="javascript:void(0)" className="mb-7">
              <img alt="Logo" src="/media/logos/INSIGHT-negativo.png"  style={{width:"150px"}} />
            </a>

            <h2 className="text-white fw-normal m-0"> 
             Admininistrator Dashboard
            </h2>

          </div>
        </div>
        <div className="d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-12 p-lg-20">

          <div className="bg-body d-flex flex-column align-items-stretch flex-center rounded-4 w-md-600px p-20">

            <div className="d-flex flex-center flex-column flex-column-fluid px-lg-10 pb-15 pb-lg-20">

              <Outlet />

            </div>
          </div>
        </div>
      </div>
    </>
  );

}

export { AuthLayout }
